import Grid from '@/global/components/ui/Grid'
import { estadosV2, getCidadesByUf } from '@acme/common'
import { Autocomplete, Divider, TextField } from '@mui/material'
import axios from 'axios'
import { FormField, FormFieldSelect } from 'global/components/Form'
import { ChangeEvent, useEffect, useState } from 'react'
import { useFormContext } from 'react-hook-form'
import { ViaCepApi } from 'types'

export function DadosEndereco() {
    const [cidades, setCidades] = useState<
        Array<{ value: string; label: string }>
    >([])

    const {
        watch,
        setValue,
        getValues,
        control: {
            _options: { disabled },
        },
    } = useFormContext()

    const uf = watch('uf'),
        ibge = watch('Cidade.ibge')

    function handleChangeCep(event: ChangeEvent<HTMLInputElement>) {
        const cep = event.target.value.replace(/\D/g, '')
        if (cep.length === 8) {
            axios
                .get<ViaCepApi>(`https://viacep.com.br/ws/${cep}/json/`)
                .then(
                    async ({
                        data: { logradouro: endereco, bairro, ibge, uf },
                    }) => {
                        setValue('uf', uf)
                        if (!getValues('endereco'))
                            setValue('endereco', endereco)
                        if (!getValues('bairro')) setValue('bairro', bairro)
                        await updateCidadesByUf(uf)
                        setValue('Cidade.ibge', Number(ibge))
                    },
                )
        }
    }

    async function updateCidadesByUf(uf: string) {
        if (!uf) return
        const cidades = await getCidadesByUf(uf)
        setCidades(
            cidades.map(c => ({
                value: String(c.id),
                label: c.nome,
            })),
        )
        if (
            ibge &&
            !cidades.find(cidade => Number(cidade.id) === Number(ibge))
        ) {
            setValue('Cidade.ibge', null)
        }
    }

    useEffect(() => {
        updateCidadesByUf(uf)
    }, [uf])

    return (
        <section id="endereco">
            <Divider className="my-4 select-none">Endereço</Divider>
            <Grid container spacing={2} columns={24}>
                <Grid item xs={6}>
                    <FormField
                        name="cep"
                        label="CEP"
                        required
                        onChange={handleChangeCep}
                        options={{
                            blocks: [5, 3],
                            delimiter: '-',
                            numericOnly: true,
                        }}
                    />
                </Grid>
                <Grid item xs={4}>
                    <FormFieldSelect
                        name="uf"
                        label="UF"
                        required
                        options={estadosV2.map(({ sigla }) => ({
                            value: sigla,
                            label: sigla,
                        }))}
                    />
                </Grid>
                <Grid item xs={14}>
                    <Autocomplete
                        disabled={disabled}
                        options={cidades}
                        value={
                            ibge
                                ? cidades.find(o => o.value === String(ibge)) ??
                                  null
                                : null
                        }
                        onChange={(_, v) => {
                            setValue('Cidade.ibge', v?.value ?? null)
                        }}
                        isOptionEqualToValue={(option, value) =>
                            option.value === value?.value
                        }
                        renderInput={props => (
                            <TextField
                                {...props}
                                variant="filled"
                                label="Cidade de trabalho"
                                required
                            />
                        )}
                        getOptionKey={o => String(o.value)}
                    />
                </Grid>
                <Grid item xs={8}>
                    <FormField name="bairro" label="Bairro" required />
                </Grid>
                <Grid item xs={11}>
                    <FormField name="endereco" label="Endereço" required />
                </Grid>
                <Grid item xs={5}>
                    <FormField name="numero" label="Número" required />
                </Grid>
            </Grid>
        </section>
    )
}
